/** Returns the cached value for key, computing it once; past `limit` entries the least recently used goes. */
export function lruCached<T>(
	cache: Map<string, T>,
	limit: number,
	key: string,
	compute: () => T,
): T {
	const hit = cache.get(key)
	if (hit !== undefined) {
		cache.delete(key)
		cache.set(key, hit)
		return hit
	}
	const value = compute()
	cache.set(key, value)
	if (cache.size > limit) {
		const oldest = cache.keys().next().value
		if (oldest !== undefined) cache.delete(oldest)
	}
	return value
}
